<script setup>
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import referenceImg from "./assets/reference.png";

defineProps({
  open: { type: Boolean, default: false },
});

const emit = defineEmits(["update:open"]);

function handleOpenChange(val) {
  emit("update:open", val);
}
</script>

<template>
  <Dialog :open="open" @update:open="handleOpenChange">
    <DialogContent class="sm:max-w-[800px] max-h-[85vh] flex flex-col">
      <DialogHeader>
        <DialogTitle class="text-red-500">{{ $t("Проект") }}</DialogTitle>
      </DialogHeader>

      <div class="flex-1 overflow-y-auto">
        <img
          :src="referenceImg"
          alt="Справка о наличии наследственного дела"
          class="w-full h-auto"
        />
      </div>
    </DialogContent>
  </Dialog>
</template>
